import React from 'react'
import SimpleTextBox from '../SimpleTextBox'
import { size } from 'lodash'
import '../../index.scss'
import { multiSelectItems } from 'pages/Output/DashboardNowcasting/constants'

const SubGrid = ({ id, items = [], selectedItems = [], comparingEnabled }) => {
  const renderBody = () => {
    let renderItemsIndex = []
    for (let i = 0; i < size(items); i++) {
      if (selectedItems.map(({ id }) => id).includes(i))
        renderItemsIndex.push(i)
    }

    return renderItemsIndex.map((idx) => {
      return (
        <div className='ovs-grid-wrapper-item'>
          <SimpleTextBox
            {...items[idx]}
            postfix={comparingEnabled ? '%' : multiSelectItems[idx]?.symbol}
          ></SimpleTextBox>
        </div>
      )
    })
  }

  return (
    <div id={id} className='ovs-main-container-item'>
      <div
        class='ovs-grid-wrapper'
        style={{
          '--rowNum': 1,
          '--colNum': size(selectedItems),
          '--gridHeight': '3vh'
        }}
      >
        {renderBody()}
      </div>
    </div>
  )
}

export default SubGrid
